var CONSTANTS = {
  API_ERRORS: {
    TIMEOUT:        'timeout',
    CREDENTIALS:    'credentials',
    DOMAIN:         'domain',
    AUTHORIZATION:  'authorization',
    DB_ERROR:       'DBError'
  },
  PERMISSIONS: {
    VIEW:                 0x0001,
    ADD:                  0x0002,
    EDIT_ALL:             0x0004,
    EDIT_OWN:             0x0008,
    TARDY:                0x0020,
    UPDATE_FINANCE:       0x0040,
    UPDATE_LIBRARY:       0x0080,
    UPDATE_GPA:           0x0100,
    ROSTERS:              0x0200,
    USERS:                0x0400,
    REPORTS:              0x0800,
    VIEW_BY_STUDENT:      0x1000
  }
}

module.exports = CONSTANTS;



// WEBPACK FOOTER //
// ./src/constants.js